const scrollToPoint = (topPoint: number) => {
  return window.scrollTo({
    top: topPoint,
    left: 0,
    behavior: 'smooth',
  });
};

export default scrollToPoint;
